import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Box, Typography, Button } from '@mui/material';
import { Home } from '@mui/icons-material'; // MUI Home Icon
import { Star } from '@mui/icons-material'; // Sparkles or similar icon from MUI
import LoanEnquiryModal from './LoanEnquiryModal'; // Import LoanEnquiryModal component
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import actions from "../../Redux Store/actions";

const LoginLoanModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [animateIn, setAnimateIn] = useState(false); // Animation state
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false); // State for LoanEnquiryModal
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const isModalShown = useSelector((state) => state.Auth.isModalShown); // Get modal state from Redux

  useEffect(() => {
    if (!isModalShown) {
      setAnimateIn(true); // Trigger animations when the modal opens
      dispatch(actions.setModalShown()); // Dispatch action to update modal state
    }

    return () => {
      setAnimateIn(false); // Reset animation on modal close
    };
  }, [isModalShown, dispatch]);
  React.useEffect(() => {
    // Trigger animations when the modal opens
    if (open) {
      setAnimateIn(true);
    }
  }, [open]);

  // const handleEnquireNow = () => {
  //   setLoading(true);
    
  //     setLoading(false);
  //     setIsSecondModalOpen(true); // Open LoanEnquiryModal after enquiry
  //   onClose(); // Close the current modal
  // };

  const handleCloseSecondModal = () => {
    setIsSecondModalOpen(false); // Close LoanEnquiryModal
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'auto',
          p: 1,   
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 3,
            maxWidth: 600,
            width: '100%',
            boxShadow: 24,
          }}
        >
          <Box sx={{ position: 'relative', width: '100%' }}>
            {/* Animated Gradient Background */}
            <Box
              sx={{
                position: 'relative',
                px: 6,
                pt: 8,
                pb: 10,
                textAlign: 'center',
                overflow: 'hidden',
                background: 'linear-gradient(135deg, #1570ef, rgba(34, 47, 121, 0.8))', // Updated gradient color
                borderRadius: 2,
              }}
            >
              {/* Animated Circles */}
              <Box
                sx={{
                  position: 'absolute',
                  top: '-10%',
                  right: '-10%',
                  width: 160,
                  height: 160,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'all 1s ease',
                  transform: animateIn ? 'scale(1)' : 'scale(0)',
                  opacity: animateIn ? 1 : 0,
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: '-8%',
                  left: '-8%',
                  width: 128,
                  height: 128,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'all 1s ease',
                  transform: animateIn ? 'scale(1)' : 'scale(0)',
                  opacity: animateIn ? 1 : 0,
                  delay: '0.2s',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 8,
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 140, 0, 0.15)',
                  transition: 'all 1s ease',
                  transform: animateIn ? 'scale(1)' : 'scale(0)',
                  opacity: animateIn ? 1 : 0,
                  delay: '0.5s',
                }}
              />

              {/* Hero Section */}
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {/* Animated Icon */}
                <Box
                  sx={{
                    mx: 'auto',
                    mb: 4,
                    transition: 'all 0.7s ease 0.2s',
                    transform: animateIn ? 'translateY(0)' : 'translateY(24px)',
                    opacity: animateIn ? 1 : 0,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '16px',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)', // Lighter opacity for background
                      backdropFilter: 'blur(5px)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Home sx={{ color: '#ff9800', fontSize: 32 }} /> {/* Home Icon */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: '#ff9800', // Sparkles background color
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Star sx={{ color: '#fff', fontSize: 14 }} /> {/* Sparkles Icon */}
                    </Box>
                  </Box>
                </Box>

                {/* Title with Animation */}
                <Typography
                  sx={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#fff',
                    mb: 2,
                    lineHeight: 1.3,
                    transition: 'all 0.7s ease 0.3s',
                    transform: animateIn ? 'translateY(0)' : 'translateY(24px)',
                    opacity: animateIn ? 1 : 0,
                  }}
                >
                  Unlock Your Dream Home with{' '}
                  <span style={{ color: '#ff9800' }}>VJ Loan Assist!</span>
                </Typography>

                {/* Description with Animation */}
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: 'rgba(255, 255, 255, 0.8)',
                    maxWidth: '480px',
                    mx: 'auto',
                    transition: 'all 0.7s ease 0.5s',
                    transform: animateIn ? 'translateY(0)' : 'translateY(24px)',
                    opacity: animateIn ? 1 : 0,
                  }}
                >
                  Exclusive loan offers with low interest rates for VJ customers.
                  Get quick, easy, and hassle-free home loan assistance!
                </Typography>
              </Box>
            </Box>

            {/* Enquire Button */}
            <Box sx={{display: 'flex', justifyContent: 'center', flexDirection: 'column', mt: 4, textAlign: 'center',gap: 2}}>
              <Button
                sx={{
                  backgroundColor: '#e67e22',
                  color: '#fff',
                  p: '12px 24px',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  fontFamily: "Inter-Medium",
                  letterSpacing: '0.9px',
                  borderRadius: 2,
                  '&:hover': {
                    backgroundColor: '#d35400',
                  },
                }}
                // onClick={handleEnquireNow}
                onClick={() => navigate("/Home/LoanAssist")}
                disabled={loading}
              >
                {loading ? 'Enquiring...' : 'Enquire Now'}
              </Button>

              <Button
                sx={{
                  backgroundColor: '#f6f7f9',
                  color: '#555',
                  p: '12px 24px',
                  fontWeight: 'bold',
                  border:"1px solid #555",
                  fontSize: '12px',
                  fontFamily: "Inter-Medium",
                  letterSpacing: '0.9px',
                  borderRadius: 2,
                  '&:hover': {
                    backgroundColor: '#ffffff',
                  },
                }}
                onClick={onClose}
                disabled={loading}
              >
                May Be Later
              </Button>
            </Box>

            {/* Footer */}
            <Typography
              sx={{
                fontSize: '12px',
                color: '#555',
                mt: 3,
                textAlign: 'center',
              }}
            >
              Your data is secure. All transactions comply with RBI guidelines.
            </Typography>
          </Box>
        </Box>
      </Modal>

      {/* Loan Enquiry Modal */}
      <LoanEnquiryModal
        open={isSecondModalOpen}
        onClose={handleCloseSecondModal}
      />
    </>
  );
};

export default LoginLoanModal;
